export default "__VITE_ASSET__BgrtvO1B__"